import React, { useState } from 'react';
import {
  StyleSheet,
  Button,
  Text,
  View,
  TouchableOpacity,
  Image,
  Dimensions,
} from 'react-native';

const deviceWidth = Dimensions.get('window').width;

export default function Accordion({
  renderHeader,
  renderContent,
  headerContainerStyle,
  contentContainerStyle,
}) {
  const styles = StyleSheet.create({
    header: {
      backgroundColor: 'white',
      //   padding: deviceWidth * 0.05,
    },
    content: {
      backgroundColor: 'white',
      //   padding: deviceWidth * 0.05,
    },
  });
  const [accordionVisibility, setAccordionVisibility] = useState(false);
  return (
    <View>
      <TouchableOpacity
        onPress={() => {
          setAccordionVisibility(!accordionVisibility);
        }}
      >
        <View style={[styles.header, headerContainerStyle]}>
          {renderHeader()}
        </View>
      </TouchableOpacity>
      {accordionVisibility ? (
        <View style={[styles.content, contentContainerStyle]}>
          {renderContent()}
        </View>
      ) : null}
    </View>
  );
}
